import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=4d777a4e"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports